export default __webpack_public_path__ + "static/media/ic_bhutan.f29dd2cd.svg";